import React, { useState } from 'react';

const ARTICLES = [
  {
    date: 'August 2026',
    tag: 'Research',
    title: 'Open Data Deposit: Leukocyte Composition and Ten-Year Epigenetic Drift in Blood',
    excerpt: 'Zenodo deposit v2 (code MIT; data and figures CC BY 4.0). Analysis code and derived tables for a longitudinal reanalysis of two paired cohorts (LSADT, 86 participants over 10 years, 450K whole blood; Health ABC, 16 participants over 5 years, EPIC buffy coat) testing how much apparent decade-scale change in five blood methylation measures is attributable to concurrent change in leukocyte composition: 11.5% to 41.2% of the variance in ten-year change, depending on the measure. Companion preprint in press at Research Square.',
    url: 'https://doi.org/10.5281/zenodo.22051234'
  },
  {
    date: 'July 2026',
    tag: 'Research',
    title: 'Epigenetic Age Estimates in Blood Shift by Decades with Cell Population: A Within-Donor Variance Partition Across Two Platforms and Two Study Designs',
    excerpt: 'Preprint (not peer reviewed). Within the same six healthy donors, epigenetic age estimates moved by a median of 15.6 years (Horvath) and 36.7 years (Hannum, PhenoAge) depending only on which blood cells were assayed; replicated on EPIC with donor age removed. Blood preparation must be reported as a primary methodological variable — a constraint that applies to blood-based methylation measures generally, including our own.',
    url: 'https://doi.org/10.21203/rs.3.rs-10503047/v1'
  },
  {
    date: 'July 2026',
    tag: 'Research',
    title: 'Open Data Deposit: Epigenetic Age Estimates and Blood Cell Population',
    excerpt: 'Zenodo deposit (CC BY 4.0). Analysis code, figures and derived tables supporting the epigenetic-age preprint, released so every table can be reproduced from the public GEO series GSE35069 and GSE110554.',
    url: 'https://doi.org/10.5281/zenodo.21538619'
  },
  {
    date: 'July 2026',
    tag: 'Research',
    title: 'Static DNA-Methylation Burden Discriminates Hematologic-Malignancy Subtypes but Does Not License Per-Patient Trajectory Inference',
    excerpt: 'Preprint (not peer reviewed). Public-cohort analysis reporting 96.6% specificity against a healthy whole-blood reference, with a formal identifiability framework establishing why cross-sectional burden cannot support per-patient trajectory claims — a constraint we apply to our own platform.',
    url: 'https://doi.org/10.21203/rs.3.rs-10397076/v1'
  },
  {
    date: 'July 2026',
    tag: 'Research',
    title: 'Compartment Mismatch Produces Near-Perfect Apparent Discrimination in Blood-Referenced DNA-Methylation Classifiers',
    excerpt: 'Preprint (not peer reviewed). Cases and controls drawn from different blood compartments yield AUC 1.000 and 0.972, while the one compartment-matched comparison yields 0.535 (95% CI 0.316-0.763, p=0.83) — a caution for any diagnostic validated against public cohorts, including our own.',
    url: 'https://doi.org/10.21203/rs.3.rs-10472780/v1'
  },
  {
    date: 'July 2026',
    tag: 'Research',
    title: 'Open Data Deposit: Compartment Mismatch in Blood-Referenced DNA-Methylation Classifiers',
    excerpt: 'Zenodo deposit (CC BY 4.0). Seventeen files of derived results supporting the compartment-mismatch preprint, released so the reported discrimination statistics can be reproduced from publicly available GEO series.',
    url: 'https://doi.org/10.5281/zenodo.21517032'
  },
  {
    date: 'March 2026',
    tag: 'Company',
    title: 'Alercell Unveils AI Cancer Detection Platform Validated on 199,000 Patient Records',
    excerpt: 'Alercell\'s AI-powered epigenetic diagnostic platform — validated across 199,000 patient records — is featured in AZCentral, a landmark external media validation as the company advances its Series A.',
    url: 'https://www.azcentral.com/press-release/story/49255/alercell-unveils-ai-cancer-detection-platform-validated-on-199000-patient-records/'
  },
  {
    date: 'March 2026',
    tag: 'Company',
    title: 'How to Lead Diagnostic Ventures With Ethical Responsibility',
    excerpt: 'Interview of Frederic Scheer on the ethical leadership principles guiding Alercell\'s mission to build the first agentic diagnostic system for pre-symptomatic leukemia detection.',
    url: 'https://www.thoughtpieces.com/leadership/frederic-scheer-how-to-lead-diagnostic-ventures-with-ethical-responsibility/'
  },
  {
    date: 'February 2026',
    tag: 'Company',
    title: 'How to Develop Logistics Solutions in Complex Global Healthcare Markets',
    excerpt: 'Interview of Frederic Scheer on navigating the complexities of global healthcare markets and building scalable diagnostic solutions.',
    url: 'https://valiantceo.com/frederic-scheer-how-to-develop-logistics-solutions-in-complex-global-healthcare-markets/'
  },
  {
    date: 'January 2026',
    tag: 'Science',
    title: 'Why Early Detection Is the Most Powerful Weapon in the War on Cancer',
    excerpt: 'Dr. Frederic Scheer on why detecting cancer years before symptoms appear is the most transformative intervention available — and how Alercell\'s LENA platform makes it possible.',
    url: 'https://www.randlesham.com/health/frederic-scheer-on-why-early-detection-is-the-most-powerful-weapon-in-the-war-on-cancer/'
  },
  {
    date: 'January 2026',
    tag: 'Science',
    title: 'Frederic Scheer: Harnessing AI and Genomics to Revolutionize Cancer Diagnostics',
    excerpt: 'CXO Debrief profiles Frederic Scheer on how Alercell is combining artificial intelligence and genomic data to transform the future of cancer diagnostics.',
    url: 'https://www.cxodebrief.com/healthcare/frederic-scheer-harnessing-ai-and-genomics-to-revolutionize-cancer-diagnostics/'
  },
  {
    date: 'January 2026',
    tag: 'Company',
    title: 'How Alercell Is Redefining Cancer Screening with Next-Gen Molecular Tools and Artificial Intelligence',
    excerpt: 'A deep dive into Alercell\'s proprietary molecular screening infrastructure and the AI systems powering the next generation of leukemia diagnostics.',
    url: 'https://valiantceo.com/frederic-scheer-how-alercell-is-redefining-cancer-screening-with-next-gen-molecular-tools-and-artificial-intelligence/'
  },
  {
    date: 'April 18, 2025',
    tag: 'Science',
    title: 'Building Trust in Molecular Diagnostics Through Scientific Rigor and AI Integration',
    excerpt: 'How Alercell is setting a new standard for evidence-based AI diagnostics in oncology, combining rigorous clinical validation with next-generation machine learning.',
    url: 'https://www.csuitebrief.com/ceo/frederic-scheer-building-trust-in-molecular-diagnostics-through-scientific-rigor-and-ai-integration/'
  },
  {
    date: 'March 2025',
    tag: 'Company',
    title: 'Championing Precision Diagnostics to Transform Oncology Care',
    excerpt: 'Executive Statement profiles Frederic Scheer on his mission to make precision diagnostics accessible to patients worldwide through Alercell\'s LENA platform.',
    url: 'https://www.executivestatement.com/healthcare/frederic-scheer-championing-precision-diagnostics-to-transform-oncology-care/'
  },
  {
    date: 'December 2024',
    tag: 'Company',
    title: 'How to Turn Decades of Innovation Into Life-Changing Impact',
    excerpt: 'Wolf & Grayson profiles Frederic Scheer on translating 30 years of entrepreneurial experience into a cancer diagnostics company that could save millions of lives.',
    url: 'https://www.wolfandgrayson.com/ceo/frederic-scheer-how-to-turn-decades-of-innovation-into-life-changing-impact/'
  },
  {
    date: 'December 2024',
    tag: 'Company',
    title: 'Redefining Cancer\'s Detection: Frederic Scheer Vision for Accessible Precision Testing',
    excerpt: 'CXO Dispatch covers Frederic Scheer\'s vision for making precision cancer detection accessible to all patients through AI-powered epigenetic diagnostics.',
    url: 'https://www.cxodispatch.com/leadership/ceo/redefining-cancer-detection-frederic-scheers-vision-for-accessible-precision-testing/'
  },
  {
    date: 'Aug 3, 2023',
    tag: 'Science',
    title: 'New Diagnostic Tests Could Change The Landscape For Leukemia Prevention And Treatment',
    excerpt: 'Forbes highlights how Alercell\'s next-generation diagnostic tests are poised to transform leukemia prevention and treatment through early molecular detection.',
    url: 'https://www.forbes.com/sites/omerawan/2023/08/03/new-diagnostic-tests-could-change-the-landscape-for-leukemia-prevention-and-treatment/'
  },
  {
    date: 'Apr 26, 2023',
    tag: 'Product',
    title: 'MDx Platform Offers Largest Variety of Leukemia-Related Diagnostic Tests for Early Detection',
    excerpt: 'LabMedica covers the launch of the LENA Molecular Dx Leukemia Platform — 12 next-generation molecular tests for early leukemia detection, treatment guidance, and MRD monitoring.',
    url: 'https://www.labmedica.com/molecular-diagnostics/articles/294796959/mdx-platform-offers-largest-variety-of-leukemia-related-diagnostic-tests-for-early-detection.html'
  },
  {
    date: 'Mar 23, 2023',
    tag: 'Company',
    title: "Here's Story of an Entrepreneur's Resilience And Grit",
    excerpt: 'The story of Frederic Scheer\'s entrepreneurial journey — from personal health challenges to founding Alercell and pioneering leukemia early detection technology.',
    url: 'https://www.alercell.com/articles/here-s-story-of-an-entrepreneur-s-resilience-and-grit'
  },
  {
    date: 'Feb 13, 2023',
    tag: 'Science',
    title: "Alercell's Lena Q51 speeds time to diagnosis for leukemia",
    excerpt: 'BioWorld reports how Alercell\'s LENA Q51 test cuts leukemia diagnosis time from weeks to hours, using a standard qPCR machine to detect 51 gene mutations.',
    url: 'https://www.bioworld.com/articles/694193-alercells-lena-q51-speeds-time-to-diagnosis-for-leukemia'
  },
];

const TAGS = ['All', 'Science', 'Product', 'Company', 'Technology', 'Research', 'Partnership'];

export default function News() {
  const [activeTag, setActiveTag] = useState('All');
  const filtered = activeTag === 'All' ? ARTICLES : ARTICLES.filter(a => a.tag === activeTag);

  return (
    <main>
      {/* Hero */}
      <section className="page-hero">
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="eyebrow">News & Updates</span>
          <h1 className="hero-headline" style={{ marginBottom: 24 }}>The Alercell story, as it happens.</h1>
          <p className="body-lg" style={{ maxWidth: 600 }}>
            Company milestones, scientific publications, product launches, and perspective from the team building the first pre-symptomatic leukemia detection platform.
          </p>
        </div>
      </section>

      {/* Filter */}
      <div style={{ background: 'var(--bg-surface)', borderBottom: '1px solid var(--border)', padding: '20px 0' }}>
        <div className="container" style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {TAGS.map(tag => (
            <button key={tag} onClick={() => setActiveTag(tag)} style={{
              fontFamily: 'var(--font-mono)', fontSize: 11, cursor: 'pointer',
              color: activeTag === tag ? '#080D1A' : 'var(--text-secondary)',
              textTransform: 'uppercase', letterSpacing: '0.1em',
              padding: '6px 14px', border: '1px solid var(--border)', borderRadius: 20,
              background: activeTag === tag ? 'var(--accent-cyan)' : 'transparent',
              transition: 'all 0.2s',
            }}>{tag}</button>
          ))}
        </div>
      </div>

      {/* Articles */}
      <section className="section" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          {/* Featured article */}
          {activeTag === 'All' && filtered[0] && (
            <div style={{ background: 'var(--bg-card)', border: '1px solid var(--accent-cyan-border)', borderRadius: 'var(--radius)', padding: 48, marginBottom: 40 }}>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--accent-cyan)', textTransform: 'uppercase', letterSpacing: '0.12em', background: 'var(--accent-cyan-dim)', padding: '4px 10px', borderRadius: 20, display: 'inline-block', marginBottom: 16 }}>Latest · {filtered[0].tag}</span>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 16, lineHeight: 1.3 }}>
                <a href={filtered[0].url} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-primary)', textDecoration: 'underline' }}>{filtered[0].title}</a>
              </h2>
              <p className="body-md" style={{ marginBottom: 20 }}>{filtered[0].excerpt}</p>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-muted)' }}>{filtered[0].date}</span>
            </div>
          )}

          <div className="news-grid">
            {(activeTag === 'All' ? filtered.slice(1) : filtered).map((article, i) => (
              <div key={i} className="news-card">
                <div className="news-card-body">
                  <span className="news-tag">{article.tag}</span>
                  <div className="news-date">{article.date}</div>
                  <div className="news-title">
                    <a href={article.url} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{article.title}</a>
                  </div>
                  <p className="news-excerpt">{article.excerpt}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Substack CTA */}
      <section className="section section-surface">
        <div className="container cta-banner">
          <h2 className="section-headline">Frederic Scheer's Science Blog</h2>
          <p className="body-lg">In-depth writing on epigenetics, cancer biology, AI in medicine, and the science behind the LENA platform. Published on Substack.</p>
          <div className="cta-buttons">
            <a href="https://fscheer.substack.com" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Read on Substack ↗
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

